import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html'
})
export class NavBar2Component implements OnInit {
  public user_logged: any
  constructor(private router: Router) { 
    this.user_logged = JSON.parse(localStorage.getItem('currentUser'))

  }
  logout(){
    console.log("si funciona logout")
    sessionStorage.clear();
    localStorage.removeItem('admin');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('id');
    localStorage.removeItem('mivivienda');
    localStorage.removeItem('micondo');

  }
  ngOnInit(): void {
  }

}
